import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { QzTrayCertificate, QzTrayCertificateForm } from "../../../types/qztray/QzTrayCertificateTypes";

interface QzTrayCertificateState {
  form: QzTrayCertificateForm;
  certificates: QzTrayCertificate[];
  isLoading: boolean;
  isSubmitting: boolean;
  error: string | null;
  uploadModalOpen: boolean;
  editModalOpen: boolean; // ✅ nuevo
  certificateToEdit: QzTrayCertificate | null;
}

const initialState: QzTrayCertificateState = {
  certificates: [],
  isLoading: false,
  isSubmitting: false,
  error: null,
  form: {
    type: null,

    commonName: "Codenova POS",
    organization: "Codenova",
    organizationalUnit: "Printing",
    countryCode: "SV",
    validYears: 5,
    dnsNames: ["localhost"],
    ipAddresses: ["127.0.0.1"],

    dnsInput: "",
    ipInput: "",
  },
  uploadModalOpen: false,
  editModalOpen: false, // ✅ nuevo
  certificateToEdit: null,
};

const qzTrayCertificateSlice = createSlice({
  name: "qzTrayCertificate",
  initialState,
  reducers: {
    setCertificates(state, action: PayloadAction<QzTrayCertificate[]>) {
      state.certificates = action.payload;
      state.error = null;
    },
    addOrUpdateCertificate(state, action: PayloadAction<QzTrayCertificate>) {
      const updated = action.payload;
      const index = state.certificates.findIndex(c => c.type === updated.type);
      if (index !== -1) {
        state.certificates[index] = updated;
      } else {
        state.certificates.push(updated);
      }
    },
    removeCertificate(state, action: PayloadAction<string>) {
      state.certificates = state.certificates.filter(c => c.type !== action.payload);
    },
    updateCertificateFormField(
      state,
      action: PayloadAction<{ field: keyof QzTrayCertificateForm; value: any }>
    ) {
      const { field, value } = action.payload;
      state.form = { ...state.form, [field]: value };
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
    setSubmitting(state, action: PayloadAction<boolean>) {
      state.isSubmitting = action.payload;
    },
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },
    resetCertificates(state) {
      state.certificates = [];
      state.isLoading = false;
      state.isSubmitting = false;
      state.error = null;
    },
    setUploadModalOpen(state, action: PayloadAction<boolean>) {
      state.uploadModalOpen = action.payload;
    },
    setEditModalOpen(state, action: PayloadAction<boolean>) { // ✅ nuevo
      state.editModalOpen = action.payload;
    },
    setCertificateToEdit(state, action: PayloadAction<QzTrayCertificate | null>) {
      state.certificateToEdit = action.payload;
    },
    clearCertificateToEdit(state) {
      state.certificateToEdit = null;
    },
    resetCertificateForm(state) {
      state.form = {
        type: null,

        commonName: "Codenova POS",
        organization: "Codenova",
        organizationalUnit: "Printing",
        countryCode: "SV",
        validYears: 5,
        dnsNames: ["localhost"],
        ipAddresses: ["127.0.0.1"],

        dnsInput: "",
        ipInput: "",
      };
    },
  },
});

export const {
  setCertificates,
  addOrUpdateCertificate,
  removeCertificate,
  updateCertificateFormField,
  setLoading,
  setSubmitting,
  setError,
  resetCertificateForm,
  resetCertificates,
  setUploadModalOpen,
  setEditModalOpen, // ✅ exportar
  setCertificateToEdit,
  clearCertificateToEdit,
} = qzTrayCertificateSlice.actions;

export default qzTrayCertificateSlice.reducer;
